__turbopack_context__.v({
  "container": "LoginRegistrationContainer-module-scss-module__O8HoYa__container",
  "containerInner": "LoginRegistrationContainer-module-scss-module__O8HoYa__containerInner",
  "description": "LoginRegistrationContainer-module-scss-module__O8HoYa__description",
  "form": "LoginRegistrationContainer-module-scss-module__O8HoYa__form",
  "formContent": "LoginRegistrationContainer-module-scss-module__O8HoYa__formContent",
  "logo": "LoginRegistrationContainer-module-scss-module__O8HoYa__logo",
  "tiles": "LoginRegistrationContainer-module-scss-module__O8HoYa__tiles",
  "visual": "LoginRegistrationContainer-module-scss-module__O8HoYa__visual",
  "visualContent": "LoginRegistrationContainer-module-scss-module__O8HoYa__visualContent",
});
